<template>
  <v-layout wrap class="list-section">
    <v-flex xs12 class="text-xs-left">
      <center>
        <v-chip color="red" dark>{{account}}</v-chip>
        - {{packageOption}}
      </center>
      <center>
        <span class="pa-2">Expires On: {{expiryDate | moment("Do MMM YYYY") }}</span>
      </center>

      <center>
        <span v-if="user.active==true" class="px-2" style="color: blue">Active</span>
      </center>
      <center>
        <span v-if="user.active==false" class="pa-2" style="color: red">Account Inactive</span>
      </center>
      <center>
        <span
          v-if="user.active==false"
          class="px-2"
          style="color: red"
        >(please contact customer service)</span>
      </center>
    </v-flex>

    <v-flex xs12 class="text-xs-center avatar">
      <v-avatar :size="avatarSize" color="grey lighten-4" class="mt-5">
        <img
          v-if="user.hasProfileImage==false"
          src="https://vuetifyjs.com/apple-touch-icon-180x180.png"
          alt="avatar"
        >
        <img v-else :src="`${host}/uploads/users/${user.profileImage}`" alt="avatar">
      </v-avatar>
      <v-btn icon class="cameraBtn" @click="updateAvatar()">
        <v-icon color="white">local_see</v-icon>
      </v-btn>
    </v-flex>
    <v-flex xs12 class="text-xs-12 pl-2">
      <div v-if="(user.jobCount && user.jobCount > 25) && user.rating >= 4" class="membership">
        <span class="red--text text--darken-1">Gold</span>
        <img  src="@/assets/gold.png" alt="Gold" >
      </div>
      <div v-else-if="(user.jobCount && user.jobCount > 15) && user.rating >= 3" class="membership">
        <span class="red--text text--darken-1">Silver</span>
        <img  src="@/assets/silver.png" alt="Silver" >
      </div>
      <div v-else-if="(user.jobCount && user.jobCount >= 7) && user.rating >= 2.5" class="membership">
        <span class="red--text text--darken-1">Bronze</span>
        <img src="@/assets/bronze.png" alt="Bronze" >
      </div>
    </v-flex>
    <v-flex xs12 class="text-xs-left pl-2 mt-2">
      <v-rating
        v-bind:value="Math.round(user.rating)"
        color="yellow darken-3"
        background-color="grey darken-1"
        empty-icon="$vuetify.icons.ratingFull"
        half-increments
        hover
        readonly
      ></v-rating>
      <div v-if="user.rating" class="red--text text--darken-1 star-margin">({{formatRating(user.rating)}}/5)</div>
    </v-flex>
    <v-flex xs12 class="text-xs-left pl-2 mt-2">
      <span class="red--text">Assigned Jobs:&nbsp;</span> <b>({{user.jobCount}})</b>
    </v-flex>
    <v-flex xs12 class="text-xs-left pl-2 mt-2">
      <v-icon>person_outline</v-icon>
      {{user.firstName}} {{user.lastName}}
      <v-btn icon @click="showNameModal(user)">
        <v-icon>edit</v-icon>
      </v-btn>
    </v-flex>

    <v-flex xs12 class="text-xs-left pl-2">
      <v-icon>phone</v-icon>
      <span v-if="user.countryCode">{{user.countryCode}}</span>{{user.phone}}
      <v-btn icon @click="phoneModal(user)">
        <v-icon>edit</v-icon>
      </v-btn>
    </v-flex>
    <v-flex xs12 class="text-xs-left pl-2">
      <v-icon>mail</v-icon>
      {{user.email}}
      <v-btn icon @click="showNameModal(user)">
        <v-icon>edit</v-icon>
      </v-btn>
    </v-flex>
    <v-flex xs12 class="text-xs-left pl-2">
      <v-btn color="primary" flat :to="`/password/reset/expert`" class="text-transform-none">Update Password</v-btn>
    </v-flex>
    <v-flex xs12 class="text-xs-left pl-2">
      <v-btn color="red" flat @click="deleteModal(user)" class="text-transform-none">Delete Account</v-btn>
    </v-flex>

    <!-- Delete dialog -->
    <v-dialog v-model="dialog" max-width="600px">
      <v-toolbar dense flat>
        Avatar Update
        <v-spacer></v-spacer>
        <v-btn icon @click.native="dialog = false">
          <v-icon>clear</v-icon>
        </v-btn>
      </v-toolbar>
      <v-card>
        <v-layout wrap>
          <v-flex xs12 sm3>
            <file-upload @image="setImage"></file-upload>
          </v-flex>
          <v-flex xs12 sm9>
            <label class="red--text">PLEASE DO NOT UPLOAD PHOTOS WITH YOUR PHONE OR EMAIL CONTACTS</label>
          </v-flex>
          <v-flex xs12 sm12>
            <img v-if="imageUrl" :src="imageUrl" style="width: 150px; height: 150px; padding: 20px">
          </v-flex>
          <v-flex xs6 sm6>
            <v-btn color="green darken-1" :loading="loader" small dark @click="save">
              <v-icon>save</v-icon>Save
            </v-btn>
          </v-flex>
        </v-layout>
      </v-card>
    </v-dialog>
    <!-- End of delete dialog -->

    <!-- Name Editing -->
    <v-dialog v-model="nameDialog" max-width="700px">
      <v-card>
        <v-toolbar color="primary" flat dense dark>
          <v-toolbar-title class="title">Edit Name</v-toolbar-title>
          <v-spacer></v-spacer>
          <v-btn class="mx-0" icon @click.native="nameDialog=false">
            <v-icon color="white">clear</v-icon>
          </v-btn>
        </v-toolbar>
        <v-card-text>
          <v-container grid-list-md>
            <v-layout wrap>
              <v-flex xs12 sm6>
                <v-text-field v-model="selectedUser.firstName"></v-text-field>
              </v-flex>

              <v-flex xs12 sm6>
                <v-text-field v-model="selectedUser.lastName"></v-text-field>
              </v-flex>

              <v-flex xs12 sm12>
                <v-text-field v-model="selectedUser.email"></v-text-field>
              </v-flex>

              <v-flex xs12>
                <v-btn color="green darken-1" small dark @click="saveUpdates">
                  <v-icon left>save</v-icon>Update
                </v-btn>
              </v-flex>
            </v-layout>
          </v-container>
        </v-card-text>
      </v-card>
    </v-dialog>
    <!-- End  -->

    <!-- Delete user dialog -->
    <v-dialog v-model="userDialog" max-width="600px">
      <v-toolbar color="red" dense flat dark>
        Delete Account
        <v-spacer></v-spacer>
        <v-btn icon @click.native="userDialog = false">
          <v-icon>clear</v-icon>
        </v-btn>
      </v-toolbar>
      <v-card>
        <v-layout wrap class="pa-3">
          <v-flex xs12 sm12>
            <h3>Are you sure you want to delete your account?</h3>
          </v-flex>
          <v-flex xs12 sm12>
            <v-btn color="red" dark @click="deleteUser">Yes</v-btn>
          </v-flex>
        </v-layout>
      </v-card>
    </v-dialog>
    <!-- End of delete dialog -->

    <!-- Phone Editing dialog -->
    <v-dialog v-model="phoneDialog" max-width="600px">
      <v-toolbar color="primary" dense flat dark>
        Update your Phone No.
        <v-spacer></v-spacer>
        <v-btn icon @click.native="phoneDialog = false">
          <v-icon>clear</v-icon>
        </v-btn>
      </v-toolbar>
      <v-card>
        <v-layout wrap class="pa-3">
          <v-flex xs12 sm12 v-if="phoneRequest == false">
            <v-autocomplete
              v-validate="'required'"
              :error-messages="errors.collect('countryCode')"
              data-vv-name="countryCode"
              :items="countryCodes"
              v-model="dataItem.countryCode"
              label="Country Code"
              single-line
              item-text="text"
              item-value="text"
              required
            ></v-autocomplete>
          </v-flex>
          <v-flex xs12 sm12 v-if="phoneRequest == false">
            <v-text-field label="Rest of the Phone No." v-model="dataItem.phone"></v-text-field>
          </v-flex>
          <v-flex xs12 sm12 v-if="phoneRequest == true">
            <span style="color: red">Please fill the otp sent to your phone & email to update.(after confirmation login again)</span>
            <v-text-field label="otp" v-model="otp"></v-text-field>
          </v-flex>
          <v-flex xs12 sm12 v-if="phoneError != ''" class="mb-2">
            <span
              style="color: #b71c1c;"
            >{{ phoneError }}</span>
          </v-flex>
          <v-flex xs12 sm12 v-if="phoneRequest == false">
            <v-btn color="primary" dark @click="updatePhone">Update</v-btn>
          </v-flex>
          <v-flex xs12 sm12 v-if="phoneRequest == true">
            <v-btn color="primary" dark @click="confirmPhone">Update Phone</v-btn>
          </v-flex>
        </v-layout>
      </v-card>
    </v-dialog>
    <!-- End of phone dialog -->

    <!-- snackbar -->
    <app-snackbar ref="snackbar"></app-snackbar>
  </v-layout>
</template>

<script>
import FileUpload from "@/components/shared/file-uploader.vue";
import { mapGetters } from "vuex";
import { countryCodes } from "@/common/methods.js";
export default {
  name: "BioComponent",
  components: {
    FileUpload
  },
  computed: {
    avatarSize() {
      return `156px`;
    },
    ...mapGetters(["user"]),
    ...mapGetters(["host"]),
    ...mapGetters(["account"]),
    ...mapGetters(["packageOption"]),
    ...mapGetters(["expiryDate"])
  },
  data() {
    return {
      loader: false,
      dialog: false,
      userDialog: false,
      phoneDialog: false,
      phoneRequest: false,
      otp: null,
      image: null,
      imageUrl: null,
      selectedUser: {},
      dataItem: {},
      nameDialog: false,
      phoneError: '',
      countryCodes: countryCodes()
    };
  },
  methods: {
    showNameModal(user) {
      this.selectedUser = Object.assign({}, user);
      this.nameDialog = true;
    },
    phoneModal(user) {
      this.dataItem = Object.assign({}, user);
      this.phoneDialog = true;
      this.phoneError = '';
      this.phoneRequest = false;
    },
    deleteModal(user) {
      this.dataItem = Object.assign({}, user);
      this.userDialog = true;
    },
    deleteUser() {
      const data = { _id: this.user._id };
      const self = this;
      self.loader = true;
      const res = this.$store
        // .dispatch("post", { url: "/user/delete/expert/", data })
        .dispatch("post", { url: "/user/deactivate/", data })
        .then(res => {
          self.userDialog = false;
          self.$router.push("/login/expert/normal");
        });
    },
    updatePhone() {
      const data = { phone: this.dataItem.phone, countryCode: this.dataItem.countryCode };
      const self = this;
      self.loader = true;
      if(this.dataItem.phone.startsWith('0')) {
        self.phoneError = "If your Country Code is correct, do not start with ‘0’";
      } else if(!/^[0-9]+$/.test(this.dataItem.phone)) {
        self.phoneError = "Phone no should be Numerals only...";
      } else {
        const res = this.$store
        .dispatch("post", { url: "/user/change-phone/" + self.dataItem._id, data })
        .then(res => {
          if(res.state) {
            self.phoneRequest = true;
            self.phoneError = '';
          } else {
            self.phoneError = res.msg;
          }
        });
      }
    },
    confirmPhone() {
      const data = { otp: this.otp };
      const self = this;
      self.loader = true;
      const res = this.$store
        .dispatch("post", { url: "/user/confirm-change-phone/" + self.dataItem._id, data })
        .then(res => {
          if(res.state) {
            self.phoneRequest = false;
            self.$router.push('/phone/change/successful');
          }
        });
    },
    showNameModal(user) {
      this.selectedUser = Object.assign({}, user);
      this.nameDialog = true;
    },
    updateAvatar() {
      this.dialog = true;
    },
    setImage({ image, imageUrl }) {
      this.image = image;
      this.imageUrl = imageUrl;
    },
    save() {
      const data = new FormData();
      data.append("profileImage", this.image);
      const self = this;
      self.loader = true;
      const res = this.$store
        .dispatch("put", { url: "/user/update/" + this.user._id, data })
        .then(res => {
          self.$store.commit("setUser", res.user);
          self.loader = false;
          self.image = null;
          this.imageUrl = null;
          self.dialog = false;
        });
    },
    saveUpdates() {
      const data = {
        firstName: this.selectedUser.firstName,
        lastName: this.selectedUser.lastName,
        email: this.selectedUser.email
      };
      const self = this;
      self.loader = true;
      const res = this.$store
        .dispatch("put", { url: "/user/update/" + this.user._id, data })
        .then(res => {
          self.$store.commit("setUser", res.user);
          self.loader = false;
          self.nameDialog = false;
        });
    },
    formatRating(rating) {
        return parseFloat(rating.toFixed(1));
    }
  }
};
</script>

<style scoped>
.avatar {
  margin-right: 80px;
  margin-top: -25px;
  position: relative;
  z-index: 1;
}

.cameraBtn {
  margin-left: -135px;
  margin-bottom: -110px;
  z-index: 1;
}
.membership {
  display: flex;
}
.membership span {
  margin: auto 5px;
}
.membership img {
  width: 32px; 
  height: 40px
}
.star-margin {
  margin-top: 8px;
  margin-left: 4px;
}
</style>
